import { GlobalSettingsKeys, } from '@sas/nova-commons/components/Settings';
import { getFormatterLocale } from '../../../config';
export const globalSettingsDataProvider = {
    setSettings: (data) => {
        return Promise.resolve({
            items: data,
        });
    },
    getSettings: () => {
        const formatterLocale = getFormatterLocale();
        return Promise.resolve({
            items: formatterLocale
                ? [
                    {
                        id: GlobalSettingsKeys.FORMAT_LOCALE_KEY,
                        value: formatterLocale,
                    },
                ]
                : [],
        });
    },
    hasWriteAccess: () => Promise.resolve(true),
    deleteSettings: () => Promise.reject('deleteSettings not supported'),
    getTheme: () => {
        return Promise.resolve({ id: 'sas_corporate' });
    },
};
